import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { peersRelationIdSelector, selectedRelationIdSelector } from 'selectors/peergroupSelectors'

export const networthSummaryAppSelector = (state: State) =>
  state.app.networth.summary

const networthSummaryDataSelector = (state: State) =>
  state.data.networth.summary

export const networthSummaryAmountSelector = createSelector(
  networthSummaryDataSelector,
  (data) => data ? data.amount : null
)

export const networthSummaryDeltaSelector = createSelector(
  networthSummaryDataSelector,
  networthSummaryAppSelector,
  (data, { timeframe }) => {
    if (!data || !timeframe) {
      return null
    }

    return data.delta[timeframe]
  }
)

export const networthSummaryRankSelector = createSelector(
  networthSummaryDataSelector,
  networthSummaryAppSelector,
  selectedRelationIdSelector,
  (data, app, selectedRelationId): number | null => {
    if (!data || !app) {
      return null
    }

    const { relationId } = app

    return relationId
      ? data.peergroup_rank[relationId]
      : selectedRelationId
        ? data.peergroup_rank[selectedRelationId]
        : null
  }
)

export const isOtherPeergroupRankSelectedSelector = createSelector(
  networthSummaryAppSelector,
  peersRelationIdSelector,
  ({ relationId: selectedNetworthRelationId }, peersRelationId) => {
    return !!selectedNetworthRelationId && selectedNetworthRelationId !== peersRelationId
  }
)
